import React, { useEffect, useState } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import { fetchSettings } from '../../api/admin';

const DEFAULT_LOGO =
  'https://storage.googleapis.com/flutterflow-io-6f20.appspot.com/projects/evision-wealth-bog-management-5fsiev/assets/67rajg4nyg8i/EW_Logo2022-01-1-1200x282.png';

const ExternalIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" style={{ width: '0.82rem', height: '0.82rem', flexShrink: 0, fill: 'none', stroke: 'currentColor', strokeWidth: 2.2, strokeLinecap: 'round', strokeLinejoin: 'round' }}>
    <path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6M15 3h6v6M10 14L21 3" />
  </svg>
);

const PUBLIC_LINKS = [
  { label: 'Home', href: '/' },
  { label: 'All Blogs', href: '/all-blogs' },
  { label: 'Video Blogs', href: '/video-blogs' },
];

const AdminLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [adminLogoUrl, setAdminLogoUrl] = useState(DEFAULT_LOGO);

  useEffect(() => {
    const loadSettings = async () => {
      try {
        const response = await fetchSettings();
        setAdminLogoUrl(response.data?.admin_logo_url || DEFAULT_LOGO);
      } catch (_error) {
        setAdminLogoUrl(DEFAULT_LOGO);
      }
    };

    loadSettings();
  }, []);

  const onLogout = async () => {
    await logout();
    navigate('/admin/login');
  };

  return (
    <div className="admin-shell">
      <aside className="admin-sidebar">
        <div className="brand-block">
          <p className="brand-kicker">Client Console</p>
          <img className="admin-sidebar-logo" src={adminLogoUrl} alt="Admin logo" />
        </div>

        <nav className="admin-nav">
          <p className="admin-nav-label">Manage</p>
          <NavLink to="/admin/dashboard">Dashboard</NavLink>
          <NavLink to="/admin/posts">Blogs</NavLink>
          <NavLink to="/admin/jobs">Jobs</NavLink>
          <NavLink to="/admin/profile">Profile</NavLink>
          <NavLink to="/admin/settings">Settings</NavLink>
          <NavLink to="/admin/help">Help</NavLink>
        </nav>

        <div className="admin-public-links">
          <p className="admin-nav-label">Public Site</p>
          {PUBLIC_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
              className="admin-public-link"
            >
              {link.label}
              <ExternalIcon />
            </a>
          ))}
        </div>

        <div className="admin-user-panel">
          <p>{user?.name}</p>
          <button type="button" onClick={onLogout}>
            Logout
          </button>
        </div>
      </aside>
      <main className="admin-main">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
